module.exports = __webpack_public_path__ + "img/hezuo.4c659d48.png";